export default __webpack_public_path__ + "static/media/background_day.3e11890f.jpg";